module.exports = __webpack_public_path__ + "img/us2.50162f60.svg";